import React from 'react';

import OprimizedImage from '../OptimizedImage';

export default () => {
  return (
    <div className="container my-4">
      <div className="row">
        <div className="col">
          <h2 className="subtitle bigger">Take a look inside</h2>
        </div>
      </div>
      <div className="mb-5 mt-4">
        <OprimizedImage src="Ulam-Labs-Team-Photo.png" />
      </div>
    </div>
  );
};
